import styled from 'styled-components';

export const WidgetActions = styled.div`
  position: absolute;
  right: 34px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 5px;
`;

export const TableWrapper = styled.div`
  margin-top: 5px;
  flex-grow: 1;

  .BaseTable__row-cell {
    .action-bar {
      display: none;
    }

    &:hover {
      .action-bar {
        display: block;
      }
    }
  }
`;

export const DimensionTableContainer = styled.div<{ width: number }>`
  flex-flow: wrap;
  flex-grow: 1;
  justify-content: space-between;
  height: fit-content;
  background-color: #e9edf0;
  margin: 2.5px;
  padding: 3px;
  box-sizing: border-box;
  margin-top: 0;
  overflow: hidden;
  width: auto;
  display: grid;
  grid-template-columns: ${(props) => `repeat(auto-fill,minmax(${props.width}px, 1fr))`};
  grid-auto-rows: 47px;
  gap: 10px;
`;

export const DimensionHeader = styled.div`
  /* display: flex; */
  margin: 20px 10px;
`;

export const DimensionNameWrapper = styled.div`
  display: inline-block;
  height: 32px;
  font-size: 14px;
  padding: 0 11px;
  color: rgb(0 0 0 / 25%);
  background: rgb(0 0 0 / 4%);
  width: 280px;
  background-color: #f8fafb;
  border-bottom: 1px solid #e5e9ec;
  border-right: 1px solid #e5e9ec;
  line-height: 31px;
  font-weight: 600;
  margin-top: -5px;
  margin-left: -10px;
`;

export const DimensionTableWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 5px 10px;
  box-sizing: border-box;
  flex-grow: 0;
  border-radius: 6px;
  height: 100%;

  &:hover {
    .remove-dimension-btn {
      opacity: 1;
    }

    .drag-handle {
      opacity: 1;
    }
  }
`;

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RCATablesContainer = styled.div`
  position: relative;
  height: 500px;
  background-color: #fff;
  display: flex;
  padding: 5px 10px;
  flex-direction: column;

  .BaseTable__row-cell {
    position: relative;

    .action-bar {
      display: none;
    }

    &:hover {
      .action-bar {
        display: block;
      }
    }
  }
`;

export const RCANetworkRequsetNameContainer = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const TableColumnHeader = styled.div`
  height: 50px;
  line-height: 50px;
  position: relative;

  .BaseTable__header-cell {
    padding-right: 16px;
  }

  .BaseTable__header-cell-text {
    white-space: nowrap;
  }

  .BaseTable__sort-indicator {
    margin-right: 3px;
  }

  .BaseTable__column-resizer {
    visibility: hidden;
  }

  & button {
    position: absolute;
    right: 4px;
    top: 10px;
    border: none;
    background: none;
  }

  &:hover button {
    display: inline-block;
  }

  &:hover .BaseTable__column-resizer {
    visibility: 1;
  }
`;
